module.exports = __webpack_public_path__ + "img/backpack.be5030ca.webp";